module.exports = __webpack_public_path__ + "img/spring_trip-20160416-8.96f36f19.jpg";